export default "__VITE_ASSET__fb_NJ$fI__"